module.exports = __webpack_public_path__ + "static/media/import.63ac74c5.svg";